import React from 'react';

import { Form, Input } from 'antd';
import styled from 'styled-components';

import CloseIcon from 'common/Icons/CloseIcon';
import { ContractBenefitCategory } from 'types/contracts';

import ShopDataModalAddButtonPill from '../common/ShopDataModalAddButtonPill';
import { FIELD_CATEGORY } from '../constants';
import { testIdFormattedLabel } from '../testIdUtils';

const Row = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 10px;
  height: 37px;

  .delete-benefit-button {
    display: none;
  }

  &:hover {
    .delete-benefit-button {
      display: flex;
    }
  }
`;

const StyledCloseIcon = styled.div`
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: 10px;
  padding-left: 28px;
  border-bottom: 1px solid var(--line-gray);
  padding-top: 10px;
`;

const StyledInput = styled(Input)`
  background-color: var(--background-gray);
  border: 1px solid var(--line-gray);
  border-radius: 0px;
  font-size: 14px;
  height: 37px;
`;

const CategoryLabel = styled.div`
  font-family: var(--font-bold);
  font-size: 16px;
  margin: 10px 0;
  border-bottom: 1px solid var(--line-gray);
  padding-left: 30px;
  padding-bottom: 5px;
`;

const StyledShopDataModalAddButtonPill = styled(ShopDataModalAddButtonPill)`
  margin-bottom: 20px;
`;

type Props = {
  category: ContractBenefitCategory;
  contractId: number;
  communityId: number | undefined;
  disabled: boolean | undefined;
};

const ShopDataModalContractBenefitsCategory = ({ category, contractId, communityId, disabled }: Props) => {
  return (
    <>
      <CategoryLabel data-test-id={`${testIdFormattedLabel(category?.name)}-title`}>{category?.name}</CategoryLabel>
      <Form.List name={[FIELD_CATEGORY.CONTRACT_BENEFITS, contractId.toString(), category?.id.toString()]}>
        {(fields, { add, remove }) => (
          <Content>
            {fields.map(({ key, name, ...restField }) => (
              <Row key={key}>
                <Form.Item
                  {...restField}
                  name={[name, 'benefit']}
                  style={{ width: 'calc(100% - 26px)', marginBottom: 0 }}
                >
                  <StyledInput placeholder="Enter another benefit" data-test-id={`${testIdFormattedLabel(category?.name)}-input`} />
                </Form.Item>
                <StyledCloseIcon onClick={() => remove(name)} className="delete-benefit-button">
                  <CloseIcon size={16} />
                </StyledCloseIcon>
              </Row>
            ))}
            <StyledShopDataModalAddButtonPill
              label="Add Benefit"
              style={{ width: '120px' }}
              onClick={() =>
                add({
                  benefit: '',
                  contract_id: contractId,
                  community_id: communityId,
                  category_id: category?.id,
                })
              }
              dataTestId={`${testIdFormattedLabel(category?.name)}-add-btn`}
            />
          </Content>
        )}
      </Form.List>
    </>
  );
};

export default ShopDataModalContractBenefitsCategory;
